import { TabbedContentEntry } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'

/**
 * Creates a mock TabbedContentEntry
 * @param overrides - Partial fields to override defaults
 * @returns Complete TabbedContentEntry mock
 */
export function createTabbedContentEntry(
  overrides: Partial<TabbedContentEntry> = {}
): TabbedContentEntry {
  return {
    _uid: '8685e05a-12f6-4df9-94a1-0cdfa64045fd',
    image: createStoryblokAsset({
      id: 1234,
      alt: 'null',
      focus: 'null',
      title: 'null',
      source: 'null',
      filename: '',
      copyright: 'null',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    button: [],
    headline: 'Tabbed Content Entry',
    component: 'tabbed-content-entry',
    description: 'Non velit sunt qui sint fugiat qui Lorem.',
    _editable:
      '<!--#storyblok#{"name": "tabbed-content-entry", "space": "228071", "uid": "8685e05a-12f6-4df9-94a1-0cdfa64045fd", "id": "300939517"}-->',
    ...overrides,
  }
}
